// Resto del sitio: builder en runtime, home, horario, cookies, páginas de error — Português (Brasil). Mesmas chaves que es/site.ts.
export const sitePt = {
  embeds: {
    howItWorks: 'Como funciona?',
    benefitsTitle: 'Benefícios',
    contactInfo: 'Informações de contato',
    phone: 'Telefone',
    email: 'E-mail',
    emails: 'E-mails',
    openingHours: 'Horário de atendimento',
    teamTitle: 'Nossa Equipe',
    agendar: {
      step1Title: 'Escolha a loja',
      step1Desc: 'Selecione onde você quer nos visitar.',
      step2Title: 'Escolha o dia e o horário',
      step2Desc: 'Veja a disponibilidade e reserve seu horário.',
      step3Title: 'Deixe seus dados',
      step3Desc: 'Informe seu nome e contato.',
      step4Title: 'Esperamos por você',
      step4Desc: 'Você receberá a confirmação da sua visita.',
    },
  },
  whatsapp: {
    contactAria: 'Falar pelo WhatsApp',
  },
  about: {
    title: 'Sobre nós',
    knowMore: 'Saiba mais sobre ',
    fallbackName: 'nós',
    comingSoon: 'Esta página estará disponível em breve.',
  },
  error: {
    title: 'Algo deu errado',
    description: 'Ocorreu um erro inesperado ao carregar esta seção. Você pode tentar novamente.',
    retry: 'Tentar novamente',
  },
  cookies: {
    aria: 'Consentimento de cookies',
    title: 'Usamos cookies para melhorar sua experiência',
    description: 'Utilizamos cookies de terceiros (Meta, Google) para medir o tráfego e mostrar conteúdo mais relevante para você. Você pode aceitar ou recusar o uso a qualquer momento.',
    reject: 'Recusar',
    accept: 'Aceitar',
  },
  nav: {
    closeMenu: 'Fechar menu',
    openMenu: 'Abrir menu',
    menuClose: 'Fechar menu',
    menuOpen: 'Abrir menu',
    toggleTheme: 'Alternar tema',
  },
  footer: {
    rights: 'Todos os direitos reservados.',
  },
  vehicles: {
    searchPlaceholder: 'Buscar por marca, modelo ou ano...',
    searchBrand: 'Buscar marca...',
    searchYear: 'Buscar ano...',
    searchType: 'Buscar tipo...',
    noOptions: 'Nenhuma opção disponível',
    filters: 'Filtros',
    reset: 'Redefinir',
    back: 'Voltar',
    clear: 'Limpar',
    hideFilters: 'Ocultar filtros',
    showFilters: 'Mostrar filtros',
    priceRange: 'Faixa de preço',
    brand: 'Marca',
    dealership: 'Loja',
    year: 'Ano',
    vehicleType: 'Tipo de veículo',
    fuel: 'Combustível',
    condition: 'Condição',
    color: 'Cor',
    carType: 'Tipo de veículo',
    transmission: 'Câmbio',
    priceFromTo: 'Preço de - até',
    yearFromTo: 'Ano de - até',
    allMasc: 'Todos',
    allFem: 'Todas',
    exploreStock: 'Explore nosso estoque',
    priceOnRequest: 'Sob consulta',
    viewDetails: 'Ver detalhes',
    available: 'Disponível',
    kmsUnit: 'km',
    vehicleAlt: 'Veículo',
    noneAvailableTitle: 'Nenhum veículo disponível',
    noneAvailableText: 'No momento não há veículos para mostrar',
    noResultsTitle: 'Nenhum veículo encontrado',
    noResultsText: 'Tente ajustar os filtros',
    noResultsTextSearch: 'Tente ajustar os filtros ou buscar outra coisa',
    removeAllFilters: 'Remover todos os filtros',
    found: 'veículos encontrados',
    noMatches: 'Nenhum veículo corresponde aos filtros selecionados.',
    sortBy: 'Ordenar por',
    sortDateDesc: 'Mais recentes primeiro',
    sortDateAsc: 'Mais antigos primeiro',
    sortPriceAsc: 'Preço: menor para maior',
    sortPriceDesc: 'Preço: maior para menor',
    sortYearDesc: 'Ano: mais recente',
    sortYearAsc: 'Ano: mais antigo',
    sortMileageAsc: 'Quilometragem: menor para maior',
    scrollLeft: 'Rolar para a esquerda',
    scrollRight: 'Rolar para a direita',
    types: {
      all: 'Todos',
      suv: 'SUVs',
      sedan: 'Sedãs',
      hatchback: 'Hatches',
      pickup: 'Picapes',
      camioneta: 'Caminhonetes',
      van: 'Vans',
      coupe: 'Cupês',
      wagon: 'Peruas',
      trabajo: 'Veículos de trabalho',
    },
  },
  hero: {
    badge: 'Seu próximo carro espera por você',
    makeModel: 'Marca e modelo',
    makeModelPlaceholder: 'Ex.: Toyota Corolla',
    from: 'De',
    to: 'Até',
    price: 'Preço',
    min: 'Mínimo',
    max: 'Máximo',
    model: 'Modelo',
    search: 'Buscar',
    featuredCarAlt: 'Carro em destaque',
    allBrands: 'Todas as marcas',
    allModels: 'Todos os modelos',
    allYears: 'Todos os anos',
    anyPrice: 'Qualquer preço',
    trustedDealer: 'Sua concessionária de confiança',
    warrantyIncluded: 'Garantia inclusa',
    flexibleFinancing: 'Financiamento flexível',
    homeDelivery: 'Entrega em domicílio',
  },
  sections: {
    learnMore: 'Saiba mais',
    meetUs: 'Conheça-nos',
    videoInvalid: 'Por favor, informe uma URL de vídeo válida (YouTube ou Vimeo).',
    videoExample: 'Ex.: https://www.youtube.com/watch?v=VIDEO_ID',
  },
  carousel: {
    empty: 'Adicione imagens ao carrossel pelo painel à direita',
    image: 'Imagem',
    previous: 'Anterior',
    next: 'Próxima',
    goTo: 'Ir para a imagem',
  },
  stats: {
    eyebrow: 'Em números',
    title: 'Nossos números',
  },
  whyUs: {
    item1Title: 'Garantia',
    item1Description: 'Todos os nossos veículos têm garantia',
    item2Title: 'Financiamento',
    item2Description: 'Opções de financiamento flexíveis',
    item3Title: 'Qualidade',
    item3Description: 'Veículos selecionados e certificados',
  },
  skeleton: {
    all: 'Todos',
    sedan: 'Sedã',
  },
  // Textos de fábrica do builder em português (mesmas chaves de es/site.ts).
  // Só os que não estão em builder2/i18n/defaultsPt.{a,b}.ts.
  builderDefaults: {
    d002: 'Título da seção',
    d003: 'Um título que acompanha a imagem',
    d004: 'Conte aqui o que você quer destacar. Este bloco combina uma imagem com texto e um botão opcional.',
    d005: 'Título do cartão',
    d006: 'Uma breve descrição do que este cartão oferece.',
    d019: 'Um benefício em destaque',
    d020: 'Explique em uma linha por que vale a pena para o cliente.',
    d106: 'Comprador de um Toyota Corolla',
    d108: 'Compradora de um Honda CR-V',
    d110: 'Comprador de um Nissan Sentra',
    d199: 'Se você não ficar satisfeito, devolvemos seu dinheiro',
  },
};
